import { polygon } from "viem/chains";
import { config } from "@imtbl/sdk";

export const environment = {
    vip_staking_contract_address: "0x927a936AdF429773597a65096eec996bca8d278A",
    mee_token_address: "0xEB7eaB87837f4Dad1bb80856db9E4506Fc441f3D",
    subgraph_url: "https://api.thegraph.com/subgraphs/name/supermutecx/medieval-empires-staking-v2",
    vip_staking_subgraph_url: "https://api.thegraph.com/subgraphs/name/supermutecx/medieval-empires-staking-v2",
    mongo_api_base_url: `https://eu-central-1.aws.data.mongodb-api.com/app/${process.env.GATSBY_REALM_APP_ID}/endpoint`,
    purchase_usdc_contract_address: "0xCe2e222fA77D30b71081492CdaA57A18CCA2E592",
    purchase_usdt_contract_address: "0x7E1Ef3cE145174f635aDEF900006e64DD98F7f8B",
    purchase_matic_contract_address: "0xd69bA2F0871Fc8460830BfBE50242894818079aD",
    usdc_token_address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
    usdt_token_address: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
    burn_address: "0x000000000000000000000000000000000000dEaD",
    wallet_connect_project_id: "e3e55fcbc27de0146e7d93d648a83f8f",
    imx_resource_nft_address: "0x8Cb475a43633a432633526aeF0b6ED1e5C71bbeB",
    imx_client_id: "EjgLYCJOIyW2yBNmff21Fpe7HklJwfvK",
    imx_environment: config.Environment.PRODUCTION,
    imx_api_key: "sk_imapik-kMDOxTVL7GSgZBpXXLhJ_5ff9b4",
    imx_publishable_key: "pk_imapik-CnSTkaOOFQAIClJzOiyV",
    imx_chain: "imtbl-zkevm-mainnet",
    chain: polygon,
    blockExplorer: "https://polygonscan.com"
}   
